module.exports = __webpack_public_path__ + "static/media/aggregatorLogo.a55ed4cb.png";